<template>
    <div>
        <v-main>
            <div class="bg-brand">
                <!-- <div class="box"></div> -->
                <div class="brand">
                    <div class="logo">
                        <img :src="logo" alt="">
                    </div>
                    <div class="branner" v-if="statusAnimation === true">
                        <img :src="branner" alt="">
                    </div>
                </div>

                <div class="action" v-if="statusAnimation === true">
                    <v-container >
                        <div style="display:flex;justify-content:center;padding-bottom: 50px">
                           <h2 >Be Loyalty</h2>
                        </div>
                        <div style="display:flex;justify-content:center;">
                            <v-btn block style="color:#fff !important;border-radius:20px;" to="/signUp">sign up</v-btn>
                        </div>
                        <div style="display:flex;justify-content:center;padding-top:20px">
                            <span>Already have an account? <a href="##" style="color:#25388D">Login</a></span>
                        </div>
                    </v-container>
                </div>
            </div>
        </v-main>
    </div>
</template>

<script>
export default {
  name: 'LoyaltySystemBrand',

  data () {
    return {
      logo: 'https://firebasestorage.googleapis.com/v0/b/img-loyalty.appspot.com/o/Group%20785%20(1).png?alt=media&token=075ae366-ee82-4b94-ab70-19eb5980cac8',
      branner: 'https://firebasestorage.googleapis.com/v0/b/img-loyalty.appspot.com/o/Group%20785.png?alt=media&token=a18bc498-a27a-4377-9106-57416312ac3d',
      statusAnimation: false
    }
  },

  mounted () {
    setTimeout(this.setStatusAnimation, 2000)
  },

  methods: {
    signUp () {
      window.location = 'http://localhost:8081/signUp'
    },
    setStatusAnimation () {
      this.statusAnimation = true
    }

  }
}
</script>

<style scoped>

/* @media only screen and (max-width: 768px) { */
    @keyframes myAnimation {
    0% {
        opacity: 0;
        transform: translateY(100%);
        top: 50%;
    }
    100% {
        opacity: 1;
        top: 10%;
        width: 100%;
    }
}
    .bg-brand {
        background-image: url('https://firebasestorage.googleapis.com/v0/b/img-loyalty.appspot.com/o/1.%20Splash%20Screen.jpg?alt=media&token=494e4197-3a77-46d8-a5dc-73aff40fbd65');
        height: 100vh;
        width: 100%;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: flex;
        position: absolute;
        justify-content: center;
    }
    .brand {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .branner {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .branner img {
        display: flex;
        justify-content: center;
        align-items: center;
        top: 50%;
        width: 70%;
    }
    .action {
        width: 95%;
        height: 224px;
        flex-shrink: 0;
        border-radius: 20px;
        background: var(--neutral-white, #FFF);
        position: absolute;
        bottom: 10px;
        display: flex;
        justify-content: center;
    }
    .title {
        display: flex;
        justify-content: center;
        /* padding-top: 15px; */
    }
    .btn-signup {
        display: flex;
        width: 311px;
        padding: 16px 133px;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        position: absolute;
        top: 25px;
    }
    .signUp {
        border-radius: 20px;
        /* width: 327px; */
        height: 24px;
        position: absolute;
        top: 85px;
        color: #fff !important;
        /* padding: 16px 133px; */
    }
    a {
        text-decoration: none;
    }
    .login {
        position: absolute;
        top: 175px;
        color: var(--neutral-grey-2, #858494);
        display:flex;
        text-align: center;
        font-family: Rubik;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 24px */
    }
    .v-btn:not(.v-btn--round).v-size--default {
    height: 56px;
    min-width: 64px;
    padding: 0 16px;
}

@keyframes moveUp {
  0% {
    transform: translateY(100%);
    transform: scale(1);
  }
  /* 50% {
    transform: translateY(-50%);
  } */
  100% {
    /* transform: translateY(10%); */
    top: 10%;
    transform: scale(.6);
  }
}

/* Apply the animation to the element */
.logo {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 45%;
  display: flex;
        justify-content: center;
        align-items: center;
  /* background-color: red; */
  animation-delay: 2s;
  animation: moveUp 2s ease-in-out forwards;
}
/* .aa {
  color: #fff !important;
} */
/* } */
</style>



// WEBPACK FOOTER //
// src/components/V2LOYALTY_REDESIGN/brand.vue